// src/config/localeDefaults.js

const defaultValues = {
    region: "Americas",
    country: "United States of America",
    brand: "SanDisk",
  };
  
const localeDefaults = {
  "company":defaultValues,
    "en-us":defaultValues,
    "en-il":defaultValues,
    "en-us": defaultValues,
    "en-ie": {
      region: "Europe",
      country: "Ireland",
      brand: "SanDisk",
    },
    "en-gb": {
      region: "Europe",
      country: "United Kingdom",
      brand: "SanDisk",
    },
    "en-ca": {
      region: "Americas",
      country: "Canada",
      brand: "SanDisk",
    },
    "en-se": {
        region: "Europe",
        country: "Sweden",
        brand: "SanDisk",
      },
    "en-il": defaultValues,
    
      "en-ap":defaultValues,
      "en-au":defaultValues,
      "en-sg":defaultValues,
      "en-in":defaultValues,
      "de-de": {
        region: "",
        country: "Land/Region auswählen",
        brand: "SanDisk",
      },
      "de-at": {
        region: "",
        country: "Land/Region auswählen",
        brand: "SanDisk",
      },
      "fr-fr": {
        region: "",
        country: "Sélectionnez le pays / la zone",
        brand: "SanDisk",
      },
      "fr-ca": {
        region: "Americas",
        country: "Canada",
        brand: "SanDisk",
      },
      "cs-cz": {
        region: "",
        country: "Vyberte zemi/oblast",
        brand: "SanDisk",
      },
      "es-es": {
        region: "",
        country: "Seleccionar país/área",
        brand: "SanDisk",
      },
      "el-gr": {
        region: "",
        country: "Επιλογή Χώρας/Περιοχής",
        brand: "SanDisk",
      },
      "it-it": {
        region: "",
        country: "Seleziona Paese/area",
        brand: "SanDisk",
      },
      "nl-nl": {
        region: "",
        country: "Land/Regio selecteren",
        brand: "SanDisk",
      },
      "es-la": defaultValues,
      "pt-br": defaultValues,
      "zh-cn":defaultValues,
      "zh-tw":defaultValues,
      "ko-kr":defaultValues,
      "ja-jp": {
        region: "Asia-Pacific",
        country: "Japan",
        brand: "SanDisk",
      },
      "th-th":defaultValues,
      "in-id":defaultValues,
      "ru-ru":defaultValues,
      "ar-sa":defaultValues,
      "tr-tr":defaultValues,
      "pl-pl": {
        region: "",
        country: "Wybierz kraj/region",
        brand: "SanDisk",
      },
      "en-kw": defaultValues,
      "en-kz": defaultValues,
      "en-ae": defaultValues,
      "en-ua": defaultValues,
      "en-za": defaultValues,
      
  };
  
  export default localeDefaults;
  